import { CContainer, CRow, CCol, CButton} from '@coreui/react';
import React, {useEffect} from 'react';
import { CustomBreadcrumbs  } from '../../components';
import CompaniesTable from '../../components/Table/CompaniesTable';
import { AppContext } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import styles from './Companies.module.css';

const Companies = () => {
  const { state, getCompanies, companiesPageUrl} = React.useContext(AppContext);
  const navigate = useNavigate();
  const columns = [
    {
      key: '',
      label: '#',
      _props: { scope: 'col' }
    },
    {
      key: 'name',
      label: 'Empresa',
      _props: { scope: 'col' }
    },
    {
      key: 'category',
      label: 'Categoría',
      _props: { scope: 'col' }
    },
    {
      key: 'fullname',
      label: 'Responsable',
      _props: { scope: 'col' }
    },
    {
      key: 'email',
      label: 'Email',
      _props: { scope: 'col' }
    },
    {
      key: 'phone',
      label: 'Teléfono',
      _props: { scope: 'col' }
    },
    {
      key: 'branches',
      label: 'Sucursales',
      _props: { scope: 'col' }
    },
    {
      key: 'actions',
      label: 'Acciones',
      _props: { scope: 'col' }
    }
  ];

  //Effects
  useEffect(() => {
    getCompanies();
  }, [companiesPageUrl]);

  return (
    <div>
      <CustomBreadcrumbs parentTitle={'Veterinarias & lugares Pet Friendly'} activeTitle="Empresas" />
      <CContainer>
        <CRow>
          <CCol xs={12}>
            <div className={styles.orderHeader}>
              <h2 className='title mb-4'>Empresas</h2>
              <CButton 
                  size="lg" 
                  color="primary" 
                  onClick={() => navigate("/dashboard/companies/add")} 
                  className="btn-custom-yellow"
              >
                  Agregar empresa
              </CButton>
            </div>
          </CCol>
          <CompaniesTable
            columns={columns} 
            data={state?.companies} 
            pagination={state?.companiesPagination} 
          />
        </CRow>
      </CContainer>
    </div>
  );
};

export default Companies;
